import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { oktaAuth } from '../authConfig';
import { useAuth } from './AuthProvider';

const OktaCallback: React.FC = () => {
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = async () => {
    try {
      // Process the tokens from the redirect URL and store them in Okta's
      // token manager.
      await oktaAuth.handleLoginRedirect();

      // Re-run the provider's auth check so its in-memory React state
      // (isAuthenticated/user) reflects the new tokens. Writing only to
      // localStorage would leave the provider thinking we're still
      // unauthenticated until a full page reload, causing the login page to
      // render a second time after navigating home.
      await refreshAuth();

      // Home is the post-sign-in landing page. A silent re-auth started from an API call
      // records where the user was in oktaReturnTo (apiAuth.triggerOktaReauth), because
      // recovering a session should not also move them off the page they were working on.
      let returnTo = '/';
      try {
        const stored = sessionStorage.getItem('oktaReturnTo');
        if (stored) {
          returnTo = stored;
          sessionStorage.removeItem('oktaReturnTo');
        }
      } catch { /* sessionStorage unavailable */ }

      navigate(returnTo, { replace: true });
    } catch (error) {
      navigate('/');
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#0a202e',
      color: '#20cbd4'
    }}>
      <div>
        <h2>Completing sign in...</h2>
        <p>Please wait while we redirect you.</p>
      </div>
    </div>
  );
};

export default OktaCallback;
